const SignupIcon = ({
  className
}: {
  className?: string;
}) => {
  return <svg stroke={"currentcolor"} width='24px' height='24px' viewBox='0 0 24 24' fill='none' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' className={className} data-sentry-element="svg" data-sentry-component="SignupIcon" data-sentry-source-file="SignupIcon.tsx">
      <path d='M14 19C14 17.4087 13.3679 15.8826 12.2426 14.7574C11.1174 13.6321 9.5913 13 8 13C6.4087 13 4.88258 13.6321 3.75736 14.7574C2.63214 15.8826 2 17.4087 2 19' data-sentry-element="path" data-sentry-source-file="SignupIcon.tsx" />
      <path d='M8 13C10.2091 13 12 11.2091 12 9C12 6.79086 10.2091 5 8 5C5.79086 5 4 6.79086 4 9C4 11.2091 5.79086 13 8 13Z' data-sentry-element="path" data-sentry-source-file="SignupIcon.tsx" />
      <path d='M19 8V14' data-sentry-element="path" data-sentry-source-file="SignupIcon.tsx" />
      <path d='M22 11H16' data-sentry-element="path" data-sentry-source-file="SignupIcon.tsx" />
    </svg>;
};
export default SignupIcon;